import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PrivateRoutesEnum, PublicRoutesEnum } from 'src/utils/router';
import { storageToken } from 'src/utils/storage';
import CreationTest from '../../pages/CreationTest';
import Authorization from 'src/pages/Authorization';
import Dashboard from 'src/pages/Dashboard';
import ErrorHandler from 'src/components/ErrorHandler';
import TakingSurvey from 'src/pages/TakingSurvey';
import { ErrorUrlEnum } from 'src/utils/enum';
import { PublishTest } from 'src/pages/PublishTest';
import Analytics from 'src/pages/Analytics';
import { Error404 } from '../Error404';
import MySurveys from 'src/pages/MySurveys/MySurveys';

const AppRouter: React.FC = () => {
  return (
    <Switch>
      <Route path={ErrorUrlEnum.ERROR} component={ErrorHandler} />
      <Route exact path="/">
        <Redirect
          to={
            storageToken() ? PrivateRoutesEnum.DASHBOARD : PublicRoutesEnum.AUTH
          }
        />
      </Route>
      <Route path={PublicRoutesEnum.AUTH} exact component={Authorization} />
      <Route
        path={PrivateRoutesEnum.CREATE_TEST}
        exact
        component={CreationTest}
      />
      <Route path={PrivateRoutesEnum.DASHBOARD} exact component={Dashboard} />
      <Route path={PrivateRoutesEnum.MU_SURVEY} exact component={MySurveys} />
      <Route path={PrivateRoutesEnum.ANALYTICS} exact component={Analytics} />
      <Route
        path={PrivateRoutesEnum.PUBLISH_TEST}
        exact
        component={PublishTest}
      />
      <Route
        path={PublicRoutesEnum.TAKING_SURVEY}
        exact
        component={TakingSurvey}
      />
      <Route path="" component={Error404} />
    </Switch>
  );
};

export default AppRouter;
